// Кирпичный
// Монолитный
// Панельный
// Блочный
// Деревянный
// Монолитно-кирпичный
// Сталинский

import materialType from './material-type';

const options = [
    'brick',
    'monolith',
    'panel',
    'block',
    'wood',
    'monolithBrick',
    'stalin',
];

export default options.map(type => {
    return materialType.find(item => item.key === type);
});
